// App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import Home from './Pages/Home';
import ProductForm from './Components/ProductForm';
import Protanya from './Components/Protanya';
import Alldata from './Components/Alldata';
import Header from './Components/Header';
import Addproduct from './Components/Addproduct';
import PrivateRoute from './Components/PrivateRoute'; // Protect routes
import Login from './Components/Login';
import BarcodePrinter from './Components/BarcodePrinter';
import RefundList from './Components/RefundList';
import RefundForm from './Components/RefundForm';
import LabelPrinter from './Components/LabelPrinter';
import Tjdproperty from './Components/Tjdproperty';

function App() {
  return (
    <Router>
      <div>
      <Header />

      <div className='content'>          
      {/* <h3 className='tx-center'>Welcome! TJD STOCK Management</h3> */}
        <Routes>

        <Route path="/login" element={<Login />} />
          <Route path="/ProductForm" element={<PrivateRoute><ProductForm /></PrivateRoute>} />
          <Route path="/Protanya" element={<PrivateRoute><Protanya /></PrivateRoute>} />          
          <Route path="/Alldata" element={<PrivateRoute><Alldata /></PrivateRoute>} />
          <Route path="/AddProduct" element={<PrivateRoute><Addproduct /></PrivateRoute>} />
          <Route path="/BarcodePrinter" element={<PrivateRoute><BarcodePrinter /></PrivateRoute>} />

          <Route path="/RefundForm" element={<PrivateRoute><RefundForm /></PrivateRoute>} />                    
          <Route path="/RefundList" element={<PrivateRoute><RefundList /></PrivateRoute>} />
          <Route path="/LabelPrinter" element={<PrivateRoute><LabelPrinter /></PrivateRoute>} />          
          <Route path="/Tjdproperty" element={<PrivateRoute><Tjdproperty /></PrivateRoute>} />          

        </Routes>
        </div>
        
      </div>
    </Router>

  );
}

export default App;
